import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

interface HeaderSectionProps {
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  className?: string;
  customBadge?: ReactNode;
  tableSearchNode?: ReactNode;
  actionNode?: ReactNode;
}

export function HeaderSection({
  title,
  subTitle,
  className,
  customBadge,
  tableSearchNode,
  actionNode,
}: HeaderSectionProps) {
  return (
    <div
      className={cn(
        'bg-primary flex w-full items-center justify-center bg-linear-to-r text-white',
        className
      )}>
      <div className='flex w-full max-w-[1440px] flex-col space-y-2 p-4'>
        <div>{customBadge}</div>
        <div className='flex items-center justify-between gap-3'>
          <span className='text-2xl font-bold'>{title}</span>
          {actionNode}
        </div>
        {subTitle}
        {/* Search and Button Row */}
        {tableSearchNode}
      </div>
    </div>
  );
}
